import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { fetchVideos } from '../api/api';
import Item from './Item';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '30px 0px'
  },
  seeAll: {
    padding: '20px 60px'
  },
  centered: {
    marginTop: 30,
    textAlign: 'center',
    width: '100%'
  }
}));


const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
 

  useEffect(() => {
    const loadVideos = async () => {
      setIsLoading(true);
      const fetchedVideos = await fetchVideos();
      setVideos(fetchedVideos);
      setIsLoading(false);
    };

    loadVideos();
  }, []);


  const seeAll = () => {
    window.open('https://www.youtube.com/channel/UC0LAY5xS4QcxQXx5GdcoVOw/videos', '_blank');
  };

 
  const opts = {
    height: isMobile ? '285' : '405',
    width: isMobile ? '380' : '540',
    playerVars: {
      autoplay: 0,
      iv_load_policy: 3,
      loop: 1,
      rel: 0,
      modestbranding: 1,
      playlist: videos.map(v => v.youtubeUrl).join(',')
    }
  };


  return (
    <div className={classes.root}>
      {isLoading ? (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="flex-start"
            justifyContent="space-around"
          >
            {videos.map(video => (
              <Item 
                key={video._id} 
                opts={opts}
                section={video}
                width={6}
                type="video"
              />
            ))}
          </Grid>
          <div className={classes.centered}>
            <Button className={classes.seeAll} variant="raised" color="primary" onClick={seeAll}>
              SEE ALL
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Videos;